import { render, staticRenderFns } from "./Page-boxed-layout-with-mixed-menu.vue?vue&type=template&id=a999696c&"
import script from "./Page-boxed-layout-with-mixed-menu.vue?vue&type=script&lang=js&"
export * from "./Page-boxed-layout-with-mixed-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports